import { Union, Record } from "../../../fable_modules/fable-library-js.4.19.0/Types.js";
import { GlobalMessageBox_HtmlInfoWithTitle, GlobalMsg, GlobalMessageBox_Error_Z721C83C5, GlobalMsg_$reflection } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { union_type, class_type, record_type, bool_type, obj_type, lambda_type, unit_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { Dashboard_AnstehendeZahlung, Dashboard_ToggleNotificationRequest_$reflection, Dashboard_ToggleNotificationRequest, Dashboard_AnstehendeZahlung_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { FSharpResult$2 } from "../../../fable_modules/fable-library-js.4.19.0/Result.js";
import { keyValueList } from "../../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { empty, singleton, append } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { Types_RequestProperties } from "../../../fable_modules/Fable.Fetch.2.7.0/Fetch.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51 } from "../../../fable_modules/Thoth.Json.10.4.1/./Decode.fs.js";
import { CaseStrategy } from "../../../fable_modules/Thoth.Json.10.4.1/Types.fs.js";
import { sendJson, errorString, Encoders } from "../../../../Bfs.Web.Portale/./Http.fs.js";
import { fromString } from "../../../../Bfs.Web.Portale/../Bfs.Web.Kundenportal/fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { int32ToString, uncurry2 } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../../fable_modules/Thoth.Json.10.4.1/./Encode.fs.js";
import { Cmd_none } from "../../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { request } from "../../../../Bfs.Web.Portale/Http.fs.js";
import * as react from "react";
import { Page } from "../Zahlungen/Types.fs.js";
import { FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E } from "../../../fable_modules/Fable.React.9.4.0/./Fable.React.FunctionComponent.fs.js";
import { value as value_2 } from "../../../fable_modules/fable-library-js.4.19.0/Option.js";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Fable.React.UseElmish.1.0.0-beta-001/./Fable.React.UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.React.UseElmish.1.0.0-beta-001/../Fable.Elmish.4.2.0/program.fs.js";
import { bfsTile, navigationArrow } from "../Shared/Tile.fs.js";
import { notificationBox } from "./Shared.fs.js";
import { HTMLAttr } from "../../../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { spinner } from "../../../../Bfs.Web.Portale/ViewParts.fs.js";
import { asString, asMoney } from "../../../../Bfs.Web.Data.Service.Contracts/Shared.fs.js";

export class Model extends Record {
    constructor(GlobalDispatch, NavigateTo, Loading, Data, SavingToggle) {
        super();
        this.GlobalDispatch = GlobalDispatch;
        this.NavigateTo = NavigateTo;
        this.Loading = Loading;
        this.Data = Data;
        this.SavingToggle = SavingToggle;
    }
}

export function Model_$reflection() {
    return record_type("Dashboard.AnstehendeZahlungen.Model", [], Model, () => [["GlobalDispatch", lambda_type(GlobalMsg_$reflection(), unit_type)], ["NavigateTo", lambda_type(obj_type, unit_type)], ["Loading", bool_type], ["Data", Dashboard_AnstehendeZahlung_$reflection()], ["SavingToggle", bool_type]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["LoadData", "LoadDataCompleted", "ToggleBenachrichtigung", "NotificationToggled", "ShowHint", "NavigateToList"];
    }
}

export function Msg_$reflection() {
    return union_type("Dashboard.AnstehendeZahlungen.Msg", [], Msg, () => [[], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [Dashboard_AnstehendeZahlung_$reflection(), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", Dashboard_AnstehendeZahlung_$reflection()]], [["ErrorValue", class_type("System.Exception")]]])]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [class_type("Fetch.Types.Response"), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", class_type("Fetch.Types.Response")]], [["ErrorValue", class_type("System.Exception")]]])]], [], []]);
}

export function Http_loadAnstehendeZahlungen() {
    const response = fetch("/api/dashboard/anstehende-zahlung", keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(Dashboard_AnstehendeZahlung_$reflection(), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_setNotificationForAnstehendeZahlung(enabled) {
    const payload = new Dashboard_ToggleNotificationRequest(enabled);
    return sendJson("/api/dashboard/set-notification-for-anstehende-zahlung", toString(0, Auto_generateBoxedEncoder_437914C6(Dashboard_ToggleNotificationRequest_$reflection(), undefined, undefined, undefined)(payload)), singleton(new Types_RequestProperties(4, ["include"])), "POST");
}

export function State_init(props) {
    return [new Model(props.GlobalDispatch, props.NavigateTo, true, new Dashboard_AnstehendeZahlung(undefined, undefined, false), true), singleton((dispatch) => {
        dispatch(new Msg(0, []));
    })];
}

export function State_update(msg, model) {
    let bind$0040, bind$0040_1, children_6, children, s;
    switch (msg.tag) {
        case 1:
            if (msg.fields[0].tag === 1) {
                model.GlobalDispatch(new GlobalMsg(3, [GlobalMessageBox_Error_Z721C83C5("Die Daten für Ihre anstehenden Zahlungen können zur Zeit leider nicht geladen werden.")]));
                return [new Model(model.GlobalDispatch, model.NavigateTo, false, model.Data, model.SavingToggle), Cmd_none()];
            }
            else {
                return [new Model(model.GlobalDispatch, model.NavigateTo, false, msg.fields[0].fields[0], false), Cmd_none()];
            }
        case 2: {
            const newValue = !model.Data.Benachrichtigung;
            return [new Model(model.GlobalDispatch, model.NavigateTo, model.Loading, (bind$0040 = model.Data, new Dashboard_AnstehendeZahlung(bind$0040.Betrag, bind$0040.Datum, newValue)), false), request(Http_setNotificationForAnstehendeZahlung, newValue, (Item_2) => (new Msg(3, [Item_2])))];
        }
        case 3:
            if (msg.fields[0].tag === 1) {
                model.GlobalDispatch(new GlobalMsg(3, [GlobalMessageBox_Error_Z721C83C5("Ihre neuen Benachrichtigungseinstellungen können zur Zeit leider nicht gespeichert werden.")]));
                return [new Model(model.GlobalDispatch, model.NavigateTo, model.Loading, (bind$0040_1 = model.Data, new Dashboard_AnstehendeZahlung(bind$0040_1.Betrag, bind$0040_1.Datum, !model.Data.Benachrichtigung)), false), Cmd_none()];
            }
            else {
                return [new Model(model.GlobalDispatch, model.NavigateTo, model.Loading, model.Data, false), Cmd_none()];
            }
        case 4: {
            model.GlobalDispatch(new GlobalMsg(3, [GlobalMessageBox_HtmlInfoWithTitle("Anstehende Zahlungen", (children_6 = [(children = [(s = "Bitte beachten Sie, dass dies der voraussichtliche Zahlbetrag ist. Verrechnungen, Vorzugsgebühren o.ä. können ggf. noch in Abzug gebracht werden. Unter ", s)], react.createElement("span", {}, ...children)), react.createElement("a", {
                href: "/#verrechnungen",
                onClick: (_arg) => {
                    model.GlobalDispatch(new GlobalMsg(4, []));
                },
            }, "Verrechnungen"), react.createElement("span", {}, " können Sie diese hier im Portal prüfen.")], react.createElement("div", {}, ...children_6)))]));
            return [model, Cmd_none()];
        }
        case 5: {
            model.NavigateTo(new Page());
            return [model, Cmd_none()];
        }
        default:
            return [new Model(model.GlobalDispatch, model.NavigateTo, false, model.Data, true), request(Http_loadAnstehendeZahlungen, undefined, (Item) => (new Msg(1, [Item])))];
    }
}

export const View = FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E((((value_2("C:\\BuildAgent\\work\\c238671ccc1e7da2\\BfsKundenportal\\src\\Bfs.Web.Kundenportal\\WebParts\\User\\Dashboard\\AnstehendeZahlung.fs") + "#L") + int32ToString(value_2(133))) + ";") + "Dashboard.Shared.DashboardProps", value_2("View"), (props) => {
    let props_3, matchValue_5, matchValue_6, betrag, datum, children_8, children_4, children_10;
    let patternInput;
    const init = State_init(props);
    patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init, State_update, (_arg, _arg_1) => {
    }), undefined, undefined);
    const model_1 = patternInput[0];
    const dispatch = patternInput[1];
    const titleAction = react.createElement("a", {
        onClick: (_arg_2) => {
            dispatch(new Msg(5, []));
        },
    }, navigationArrow);
    const footer = model_1.Loading ? undefined : notificationBox("Benachrichtigung", model_1.Data.Benachrichtigung, model_1.SavingToggle, (_arg_3) => {
        dispatch(new Msg(2, []));
    }, "Anstehende-Zahlungen-Toggle");
    return bfsTile("Nächste anstehende Zahlung", titleAction, (props_3 = [new HTMLAttr(65, ["dashboard-icon"]), new HTMLAttr(149, [(model_1.Data.Datum != null) ? ((model_1.Data.Betrag != null) ? "dashboard/zahlung.svg" : "dashboard/zahlung_waiting_96x96.svg") : "dashboard/zahlung_waiting_96x96.svg"])], react.createElement("img", keyValueList(props_3, 1))), model_1.Loading ? spinner : ((matchValue_5 = model_1.Data.Datum, (matchValue_6 = model_1.Data.Betrag, (matchValue_5 != null) ? ((matchValue_6 != null) ? ((betrag = matchValue_6, (datum = matchValue_5, [react.createElement("div", {
        className: "is-size-7 has-text-grey-light",
    }, "Der Betrag enthält bereits den Abzug der Abrechnungsgebühr."), (children_8 = [(children_4 = [asMoney(betrag)], react.createElement("b", {
        className: "is-size-4 nowrap",
    }, ...children_4)), react.createElement("a", {
        className: "is-size-4",
        onClick: (_arg_4) => {
            dispatch(new Msg(4, []));
        },
    }, "*")], react.createElement("div", {}, ...children_8)), (children_10 = [`am ${asString(datum)}`], react.createElement("div", {
        className: "is-size-7 has-text-grey-light",
    }, ...children_10))]))) : "Keine anstehenden Zahlungen.") : "Keine anstehenden Zahlungen."))), footer);
}, undefined, undefined, "Of");

//# sourceMappingURL=AnstehendeZahlung.fs.js.map
